import { axiosApiInstance } from './axios';

// -------------------------------------------------------------

const apiRoot = '';

const userNotificationsApi = {
  // GET
  get: async (params) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/userNotifications/v2`, { params });

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  getByFactory: async (params) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/userNotifications/factory`, { params });

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  getPending: async () => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/userNotifications/pending`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  getTotalUnread: async () => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/userNotifications/totalUnread`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  // PUT
  markAsRead: async (id) => {
    try {
      const res = await axiosApiInstance.put(`${apiRoot}/userNotifications/markAsRead/${id}`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  markAsUnRead: async (id) => {
    try {
      const res = await axiosApiInstance.put(`${apiRoot}/userNotifications/markAsUnRead/${id}`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  markAllAsRead: async () => {
    try {
      const res = await axiosApiInstance.put(`${apiRoot}/userNotifications/markAllAsRead`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },
};

export default userNotificationsApi;
